import { Injectable } from '@angular/core';
import { Flag } from 'src/app/flag/model/flag';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FlagService
{
  constructor(private http: HttpClient) { }

  /**
    Save a Flag.
   *
   * @param data Flag to persit
   * @param isNew Indicate if this is a new or update
   */
  public saveFlag(data: any, isNew: boolean, flagId?: number): Observable<any>
  {
    if (isNew)
    {
      return this.http.post('/flags', data);
    }
    else
    {
      return this.http.put(`/flags/${flagId}`, data);
    }
  }

  /**
   * Get flags for member
   */
  public getFlagsForMember(memberId: number): Observable<any[]>
  {
    return this.http.get<any[]>(`/flags/member/${memberId}`);
  }

  /**
   * Get all flags for case
   */
  public getFlagsForCase(caseId: number): Observable<any[]>
  {
    return this.http.get<any[]>(`/flags/case/${caseId}`);
  }

  /**
   * Get flag from id
   */
  public getFlagById(flagId: number): Observable<any>
  {
    return this.http.get<any[]>(`/flags/${flagId}`);
  }

  /**
   * Delete a Flag.
   *
   * @param id Flag id
   */
  public deleteFlag(id: number): Observable<Flag>
  {
    return this.http.delete<Flag>(`/flags/${id}`);
  }

  /**
   * Get all flags for member
   */
  public getAllFlagsForMember(memberId: number): Observable<any[]>
  {
    return this.http.get<any[]>(`/flags/member/all/${memberId}`);
  }
}
